<template>
  <Head>
    <Title>O mně - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container color="background" class="pt-1">
    <v-row>
      <v-col cols="12" md="4">
        <v-img src="/about.jpg" aspect-ratio="1" cover/>
      </v-col>
      <v-col class="px-10">
        <h1>O mně</h1>
        <v-sheet class="py-3">
          Jmenuji se Ludmila Zacharová a jsem rodinná umělecká fotografka.
          <br>
          <br>
          Jsem pevně přesvědčena, že jsem byla předurčena stát se fotografkou.
          Moje prvni vzpominka z dětství je ohňostroj nad velkým městem, který jsem obdivovala z okna vysoké budovy.
          Nepamatuji si zvuky spojené s tímto zážitkem, ale pamatuji si barvy a tvary toho ohňostroje.
          Vedle mě byla moje maminka, cítila jsem její obrovskou lásku ke mně, stejně obrovskou jako ten ohňostroj.
          Odhalovat krásu a předávat teplé pocity pomocí fotografie je moje poslání.
          <br>
          <br>

          Rodinná fotografie je pro mě to nejcennější, protože jsem sama maminkou dvou úžasných dětí a považuji rodinu
          za to nejdůležitější v životě. Rodinná fotografie spojuje a posiluje rodinu. Umělecká a kreativní fotografie
          umožňuje předávat lásku a ostatní pozitivní emoce, které jsou v rodině přítomné.
          <br>
          <br>

          Jsem ráda, když pozoruji, jak se klienti, kteří se u mě fotili, začínají k sobě chovat něžněji,
          stávají se laskavějšími a pozornějšími ke svým milovaným. Mám radost, že mohu svým klientům umožnit
          lépe vidět sami sebe, své emoce a plně prožít radost a lásku. Někdy při práci, každodenní rutině a starostech
          zapomínáme myslet na tyto pocity. Ať Vám krásné fotografie na stěnách Vašeho domova a fotoknihy připomínají tyto okamžiky :)
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>